export const MaxLength = {
	EVENT_CODE: 256,
	RESTORE_CODE: 256
} as const;
